/**
 * TGFM Cart Bundle Manager
 * - Raggruppa visivamente PC + Upgrade in un unico box
 * - Rimuove automaticamente gli upgrade quando si rimuove il PC
 */

(function() {
  'use strict';

  const BUNDLE_CLASS = 'tgfm-bundle-wrapper';
  const BUNDLE_WITH_UPGRADES = 'tgfm-bundle-wrapper--with-upgrades';
  let bundleObserver = null;

  /**
   * Trova tutti gli upgrade associati a un prodotto
   */
  function findUpgradesForProduct(productTitle, cartItems) {
    const truncatedTitle = productTitle.substring(0, 40);
    return cartItems.filter(item => {
      const upgradeFor = item.properties && item.properties['_upgrade_for'];
      return upgradeFor && upgradeFor.startsWith(truncatedTitle.substring(0, 30));
    });
  }

  /**
   * Raggruppa visivamente i prodotti con i loro upgrade
   */
  function wrapBundles() {
    const cartList = document.querySelector('[data-cart-item-list]');
    if (!cartList) return;

    if (bundleObserver) bundleObserver.disconnect();
    try {
    // Rimuovi wrapper esistenti
    cartList.querySelectorAll('.' + BUNDLE_CLASS).forEach(wrapper => {
      wrapper.querySelectorAll('.tgfm-bundle-header').forEach(header => header.remove());
      const parent = wrapper.parentNode;
      while (wrapper.firstChild) {
        parent.insertBefore(wrapper.firstChild, wrapper);
      }
      wrapper.remove();
    });

    const items = Array.from(cartList.querySelectorAll(':scope > li.cart-item, :scope > .cart-item'));
    if (!items.length) return;

    let currentBundle = null;
    let bundleItems = [];

    items.forEach((item, index) => {
      const isUpgrade = item.classList.contains('cart-item--upgrade') ||
                        item.querySelector('.cart-upgrade-icon');

      if (!isUpgrade) {
        // Prodotto principale - chiudi bundle precedente se esiste
        if (currentBundle && bundleItems.length > 0) {
          createBundleWrapper(bundleItems, cartList);
        }

        // Inizia nuovo potenziale bundle
        bundleItems = [item];
        currentBundle = item;
      } else {
        // È un upgrade - aggiungilo al bundle corrente
        if (currentBundle) {
          bundleItems.push(item);
        }
      }
    });

    // Chiudi l'ultimo bundle
    if (currentBundle && bundleItems.length > 0) {
      createBundleWrapper(bundleItems, cartList);
    }
    } finally {
      if (bundleObserver) bundleObserver.observe(cartList, { childList: true, subtree: true });
    }
  }

  /**
   * Crea un wrapper div attorno agli elementi del bundle
   */
  function createBundleWrapper(items, container) {
    if (items.length === 0) return;

    const hasUpgrades = items.length > 1;
    const wrapper = document.createElement('div');
    wrapper.className = BUNDLE_CLASS + (hasUpgrades ? ' ' + BUNDLE_WITH_UPGRADES : '');

    // Il titolo PC CONFIGURATO e gia reso dallo stile della riga principale.

    // Inserisci il wrapper prima del primo elemento
    const firstItem = items[0];
    container.insertBefore(wrapper, firstItem);

    // Sposta tutti gli elementi nel wrapper
    items.forEach(item => {
      wrapper.appendChild(item);
    });
  }

  /**
   * Gestisce la rimozione di un prodotto - rimuove anche gli upgrade associati
   */
  function handleProductRemoval(event) {
    const removeLink = event.target.closest('[data-cartitem-remove]');
    if (!removeLink) return;

    const cartItem = removeLink.closest('.cart-item, [data-cartitem]');
    if (!cartItem) return;

    // Verifica se è un prodotto principale (non un upgrade)
    const isUpgrade = cartItem.classList.contains('cart-item--upgrade') ||
                      cartItem.querySelector('.cart-upgrade-icon');

    if (isUpgrade) return; // Se è un upgrade, lascia il comportamento normale

    // È un prodotto principale - trova e rimuovi gli upgrade associati
    const titleElement = cartItem.querySelector('.cart-item--content-title a, .cart-item--content-title');
    if (!titleElement) return;

    const productTitle = titleElement.textContent.trim();
    const truncatedTitle = productTitle.substring(0, 37); // Un po' meno di 40 per sicurezza

    // Trova tutti gli upgrade nel carrello
    const bundle = cartItem.closest('.' + BUNDLE_CLASS);
    if (!bundle) return;
    const allItems = bundle.querySelectorAll('.cart-item, [data-cartitem]');
    const upgradeKeysToRemove = [];

    allItems.forEach(item => {
      if (item === cartItem) return;

      // Verifica se è un upgrade per questo prodotto
      const upgradeInfo = item.querySelector('.cart-upgrade-info');
      if (!upgradeInfo) return;

      // Usa il data attribute per verificare il parent
      const itemKey = item.getAttribute('data-cartitem-key');
      if (itemKey) {
        upgradeKeysToRemove.push(itemKey);
      }
    });

    // Rimuovi gli upgrade via AJAX
    if (upgradeKeysToRemove.length > 0) {
      event.preventDefault();
      event.stopImmediatePropagation();

      // Prima rimuovi gli upgrade, poi il prodotto principale
      removeItemsSequentially(upgradeKeysToRemove, () => {
        // Dopo aver rimosso gli upgrade, clicca sul link di rimozione originale
        // o forza la rimozione via AJAX
        const productKey = cartItem.getAttribute('data-cartitem-key');
        if (productKey) {
          removeCartItem(productKey, () => {
            window.location.reload();
          });
        }
      });
    }
  }

  /**
   * Rimuove items dal carrello sequenzialmente
   */
  function removeItemsSequentially(keys, callback) {
    if (keys.length === 0) {
      callback();
      return;
    }

    const key = keys.shift();
    removeCartItem(key, () => {
      removeItemsSequentially(keys, callback);
    });
  }

  /**
   * Rimuove un item dal carrello via API
   */
  function removeCartItem(key, callback) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(() => {
      if (callback) callback();
    })
    .catch(err => {
      console.error('Errore rimozione item:', err);
      if (callback) callback();
    });
  }

  /**
   * Observer per aggiornamenti DOM (dopo AJAX)
   */
  function setupMutationObserver() {
    const cartContainer = document.querySelector('[data-cart-item-list]');
    if (!cartContainer) return;

    if (bundleObserver) bundleObserver.disconnect();
    bundleObserver = new MutationObserver((mutations) => {
      // Debounce per evitare chiamate multiple
      clearTimeout(window.tgfmBundleTimeout);
      window.tgfmBundleTimeout = setTimeout(wrapBundles, 100);
    });

    bundleObserver.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Inizializzazione
   */
  function init() {
    // Wrap iniziale
    wrapBundles();

    // Setup observer per AJAX updates
    setupMutationObserver();

    // Event listener per rimozione prodotti
    document.addEventListener('click', handleProductRemoval, true);
  }

  // Esegui quando DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Esegui anche dopo load completo (per sicurezza)
  window.addEventListener('load', () => {
    setTimeout(wrapBundles, 500);
  });

})();
